import { render } from "./SidebarToggle.vue?vue&type=template&id=2608ee41&scoped=true&lang=pug"
import script from "./SidebarToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarToggle.vue?vue&type=script&setup=true&lang=js"

import "./SidebarToggle.vue?vue&type=style&index=0&id=2608ee41&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2608ee41"]])

export default __exports__